import React, { Fragment, useLayoutEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { builds } from '../../resources/builds';

import { createCharacter } from '../../actions/character';


const BuildList = ({
    character,
    createCharacter
}) => {

    useLayoutEffect(() => {
        document.title = 'Select a Build - KRPG';
    }, []);

    var [confirmModal, toggleConfirmModal] = useState(false);

    const openConfirmModal = (e) => {
        toggleConfirmModal(true);
    }

    const closeModals = (e) => {
        toggleConfirmModal(false);
    }

    const submitPrebuilt = (e) => {
        openConfirmModal();
        createCharacter(character);
    }
    
    return (
        <Fragment>
            {!character.loading && (
            <div className="dash-char-list mary-2 pad-1">
                <h1 className="text-blue">Select a Character Build</h1>
                <p className="text-light1 mary-1">Character builds are designed to guide you through the process of creating and leveling up a character. Below you'll see the list of official character builds with a simple description of the expected playstyle.</p>
                <p className="text-light1">If you choose a build for your character, you will be given the choice of overriding the build and making your own changes to the character as they progress.</p>
                {builds.map(build => (
                    <div className="buildContainer mary-2">
                        <div className="buildDescriptionContainer">
                            <h1 className="text-orange">The {build.name}</h1>
                            <p className="text-light2">{build.description}</p>
                            <div className="buildExpertiseContainer">
                                <h2>Key Expertise:</h2><p>{build.keyExpertise[0]}</p><p>{build.keyExpertise[1]}</p><p>{build.keyExpertise[2]}</p>
                            </div>
                        </div>
                        <div className="buildSelectContainer">
                            <Link to="/create-character" state={{build: build.name}} className="buildSelect">SELECT</Link>
                        </div>
                        
                    </div>
                    )
                )}
            </div>
            )}
        </Fragment>
    )
}

BuildList.propTypes = {
    character: PropTypes.object.isRequired,
    createCharacter: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    character: state.character
});

export default connect(mapStateToProps, {createCharacter})(BuildList);